module.exports = __webpack_public_path__ + "media/images/gallery/constellations/andromeda/and_pn-086a3cc61c736ab1b616580548ca08e5.png";